/* @jsx m */
import m from 'mithril';
import DeviceWrapper from '../components/DeviceWrapper.jsx';
import GameContainer from '../components/GameContainer.jsx';

export default function game() {
  return {
    view: () => {
      return (
        <DeviceWrapper>
        <GameContainer />
      </DeviceWrapper>
      );
    }
  }
}